import { Link } from "react-router-dom";
import { Button } from "@/components/flexkit/Button";
import { ChevronLeft } from "lucide-react";
import { type FC } from "react";

export const GroupNotFound: FC = () => {
    return (
        <div className="flex flex-col items-center justify-center py-12">
            <h2 className="mb-2 text-xl font-semibold text-content-primary">Group not found</h2>
            <p className="mb-4 text-content-secondary">The group you&apos;re looking for doesn&apos;t exist.</p>
            <Link to="/settings/members#groups">
                <Button variant="secondary">
                    <ChevronLeft className="mr-2 size-4" />
                    Back to Groups
                </Button>
            </Link>
        </div>
    );
};
